import { useEffect, useState } from "react";
import { Modal, Typography, message } from "antd";
import { Steps } from "antd";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import { useDispatch } from "react-redux";
import { actionsApi } from "../../shared";
import { TopBar } from "./Topbar";

const { Title } = Typography;

export const Addappointment = ({
  visible,
  editID,
  clientInfo,
  onClose,
  isPRP,
  isDashboardPRP,
  isFUE,
  isDashboardFUE,
  isDraft,
  isDashboardDraft,
}) => {
  const [current, setCurrent] = useState(0);
  const dispatch = useDispatch();

  const steps = [
    { title: <Title level={5}>Client Details</Title> },
    { title: <Title level={5}>Draft</Title> },
    { title: <Title level={5}>Set Appointment</Title> },
    { title: <Title level={5}>Mark Completed</Title> },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  useEffect(() => {
    if (editID) {
      if (isPRP || isFUE) setCurrent(2);
      else setCurrent(1);
    } else {
      setCurrent(0);
    }
  }, [editID, isPRP, isFUE, isDraft]);

  const closeModal = () => {
    dispatch(actionsApi?.clearSteps());
    setCurrent(0);
    onClose();
  };

  const handleUpdateAppointment = async (formData) => {
    const tokenString = localStorage.getItem("token");
    if (!tokenString) {
      message.error("Authentication token not found.");
      return false;
    }

    let token;
    try {
      token = JSON.parse(tokenString);
    } catch {
      token = tokenString;
    }

    const headers = new Headers();
    headers.append("Authorization", `Bearer ${token}`);
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");

    const payload = {
      id: editID,
      clientID: clientInfo?.id || formData.clientID,
      medicalHistory: formData.medicalHistory || "",
      totalPayment: formData.totalPayment || 0,
      advancePayment: formData.advancePayment || 0,
      duePayment: formData.duePayment || 0,
      anyNotes: formData.anyNotes || "",
      services: (formData.services || []).map((s) => ({
        id: s.id || "",
        serviceId: s.serviceId || s.service_id,
        noOfSession: s.noOfSession || s.sessionsCount,
      })),
      sessions: (formData.sessions || []).map((s) => ({
        id: s.id || "",
        serviceId: s.serviceId || s.service_id,
        sessionDateTime: s.sessionDateTime,
        note: s.note || "",
        price: s.price || 0,
        status: s.status || "pending",
      })),
    };

    try {
      const response = await fetch(
        "https://api.hairplusinternational.com/api/appointment/update",
        {
          method: "POST",
          headers,
          body: JSON.stringify(payload),
        },
      );

      const result = await response.text();

      if (!response.ok) {
        throw new Error(result.message || "Failed to update appointment");
      }

      if (result.success) {
        message.success("Appointment updated successfully!");
        closeModal();
        return true;
      } else {
        throw new Error(result.message || "Update failed");
      }
    } catch (error) {
      console.error("Error updating appointment:", error);
      message.error("Failed to update appointment: " + error.message);
      return false;
    }
  };

  return (
    <div>
      <Modal
        title={editID ? "Edit Appointment" : "Add Appointment"}
        centered
        open={visible} // AntD v5 uses 'open' instead of 'visible'
        onCancel={closeModal}
        footer={null}
        width={1000}
        destroyOnClose
        maskClosable={false}
      >
        <div>
          <Steps
            progressDot
            current={current}
            items={items}
            labelPlacement="vertical"
            className="mb-3"
          />
          <div>
            {current === 0 ? (
              <Step1
                clientInfo={clientInfo}
                nextStep={() => setCurrent(current + 1)}
              />
            ) : current === 1 ? (
              <Step2
                clientID={clientInfo?.id}
                onClose={closeModal}
                nextStep={(data) => {
                  if (data) setCurrent(current + 1);
                  else setCurrent(current - 1);
                }}
                isDraft={isDraft}
                isDashboardDraft={isDashboardDraft}
                isFUE={isFUE}
                isDashboardFUE={isDashboardFUE}
                isPRP={isPRP}
                isDashboardPRP={isDashboardPRP}
                editID={editID}
              />
            ) : current === 2 ? (
              <Step3
                onClose={closeModal}
                nextStep={() => setCurrent(current - 1)}
                isDraft={isDraft}
                isDashboardDraft={isDashboardDraft}
                isFUE={isFUE}
                isDashboardFUE={isDashboardFUE}
                isPRP={isPRP}
                isDashboardPRP={isDashboardPRP}
                editID={editID}
                userData={{ name: clientInfo?.name, age: clientInfo?.age }}
                onSave={handleUpdateAppointment}
              />
            ) : null}
          </div>
        </div>
      </Modal>
    </div>
  );
};
